import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    show(event) {
        // relatedTarget is passed as a property of the event by Bootstrap?
        // Must use any or declare new types.
        const e = event;
        const trigger = e.relatedTarget;
        if (!trigger)
            return;
        const photoUrl = trigger.getAttribute("data-photo-url");
        if (photoUrl)
            this.imageTarget.src = photoUrl;
    }
}
default_1.targets = ["image"];
export default default_1;
